import React from 'react';
import IconLayout from '../_partials/IconLayout';
import s from './ActionBarMobile.scss';
var MAX_ICONS = 5;
// This wrapper is used to limit the maximum number of icons but also to
// make sure we fill missing spaces with empty icon containers.
// This is required so that the spacing between icons displays correctly in all cases.
var IconsWrapper = function (_a) {
    var children = _a.children;
    var icons = React.Children.toArray(children);
    var iconsIterator = Array.from(Array(MAX_ICONS).keys());
    return (React.createElement("div", { className: s['icons'] }, iconsIterator.map(function (index) { return icons[index] || React.createElement(IconLayout, null); })));
};
IconsWrapper.displayName = 'IconsWrapper';
export default IconsWrapper;
//# sourceMappingURL=IconsWrapper.js.map